import { styled } from '@mui/material/styles';
import { StepConnector, stepConnectorClasses } from '@mui/material';
import { COLOR } from '@src/styles/color';

const StyledConnector = styled(StepConnector)(() => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 16,
    left: 'calc(-50% + 10px)',
    right: 'calc(50% + 10px)',
  },
  [`& .${stepConnectorClasses.line}`]: {
    height: 4,
    border: 0,
    backgroundColor: COLOR.indigo[8],
  },
  [`&.${stepConnectorClasses.active} .${stepConnectorClasses.line}`]: {
    backgroundColor: COLOR.blueV2,
  },
  [`&.${stepConnectorClasses.completed} .${stepConnectorClasses.line}`]: {
    backgroundColor: COLOR.blueV2,
  },
}));

const StepIconRoot = styled('div')(({ ownerState }) => ({
  backgroundColor:
    ownerState.completed || ownerState.active
      ? COLOR.blueV2
      : COLOR.grayV2[150],
  zIndex: 1,
  color: COLOR.white,
  width: 32,
  height: 32,
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

export { StyledConnector, StepIconRoot };
